export default class DtoPluvioSituationDayMeasure {
    constructor(obj) {
        this.date = obj.date
        this.count = obj.count
        this.status = obj.status
    }
}